import React, { useState } from "react";
import { FmSlider } from "..";
import { useTheme } from "../../Hooks";
import useWindowDimensions from "../../Hooks/UseWindowDiemensions";
import useStyles from "./FmMaterialCard.style";

type markType = { value: number; label: string };

interface FmMaterialCardProps {
  title: string;
  description: string;
  sliderMarks: markType[];
  activeMark: number;
  type: string;
  setActiveMark: (mark: number) => void;
}

const FmMaterialCard = ({ title, description, sliderMarks, activeMark, setActiveMark, type }: FmMaterialCardProps) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const theme = useTheme();

  const isMobile = width < theme.breakpoints.values.desktop;
  const containerClass = isMobile ? classes.mobile_container : classes.container;

  let imgToShow = "";

  if (type === "soil") {
    imgToShow = `./assets/slidersPictures/soil${activeMark}.png`;
  }
  if (type === "water") {
    imgToShow = `./assets/slidersPictures/water${activeMark}.png`;
  }

  return (
    <div className={containerClass}>
      <div className={classes.title}>{title}</div>
      <div className={classes.description}>{description}</div>
      <div className={classes.img_container}>
        <img src={imgToShow} alt="ground_pic" className={classes.background_img} />
      </div>
      <div className={classes.slider_container}>
        <FmSlider activeMark={activeMark} sliderMarks={sliderMarks} setActiveMark={(active: number) => setActiveMark(active)} />
      </div>
    </div>
  );
};

export default FmMaterialCard;
